#import "../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation TravelPlanEmailCreate($input: TravelPlanEmailCreateInput!) {
  travelPlanEmailCreate(input: $input) {
    travelAuthorizationEmail {
      __typename
      id
      _planEmailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
